/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { LoginAttemptEntryFromJSON, LoginAttemptEntryToJSON, } from './';
export function LoginAttemptFromJSON(json) {
    return LoginAttemptFromJSONTyped(json, false);
}
export function LoginAttemptFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'entries': !exists(json, 'entries') ? undefined : (json['entries'] === null ? null : json['entries'].map(LoginAttemptEntryFromJSON)),
        'isBlocked': !exists(json, 'isBlocked') ? undefined : json['isBlocked'],
        'blocked': !exists(json, 'blocked') ? undefined : (json['blocked'] === null ? null : new Date(json['blocked'])),
    };
}
export function LoginAttemptToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'entries': value.entries === undefined ? undefined : (value.entries === null ? null : value.entries.map(LoginAttemptEntryToJSON)),
        'isBlocked': value.isBlocked,
        'blocked': value.blocked === undefined ? undefined : (value.blocked === null ? null : value.blocked.toISOString()),
    };
}
